import { render, staticRenderFns } from "./QuickReports.vue?vue&type=template&id=390bf907&scoped=true"
import script from "./QuickReports.vue?vue&type=script&lang=js"
export * from "./QuickReports.vue?vue&type=script&lang=js"
import style0 from "./QuickReports.vue?vue&type=style&index=0&id=390bf907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390bf907",
  null
  
)

export default component.exports